<! --
/**
* SuiteCRM is a customer relationship management program developed by SalesAgility Ltd.
* Copyright (C) 2021 SalesAgility Ltd.
*
* This program is free software; you can redistribute it and/or modify it under
* the terms of the GNU Affero General Public License version 3 as published by the
* Free Software Foundation with the addition of the following permission added
* to Section 15 as permitted in Section 7(a): FOR ANY PART OF THE COVERED WORK
* IN WHICH THE COPYRIGHT IS OWNED BY SALESAGILITY, SALESAGILITY DISCLAIMS THE
* WARRANTY OF NON INFRINGEMENT OF THIRD PARTY RIGHTS.
*
* This program is distributed in the hope that it will be useful, but WITHOUT
* ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS
* FOR A PARTICULAR PURPOSE. See the GNU Affero General Public License for more
* details.
*
* You should have received a copy of the GNU Affero General Public License
* along with this program.  If not, see http://www.gnu.org/licenses.
*
* In accordance with Section 7(b) of the GNU Affero General Public License
* version 3, these Appropriate Legal Notices must retain the display of the
* "Supercharged by SuiteCRM" logo. If the display of the logos is not reasonably
* feasible for technical reasons, the Appropriate Legal Notices must display
* the words "Supercharged by SuiteCRM".
*/
-->

<scrm-modal
    [closable]="true"
    [close]="closeButtonIcon"
    [title]="getHeaderLabel()"
    [titleKey]="titleKey"
    klass="column-chooser-modal">

    <div modal-body>

        <div class="d-flex bd-highlight">
            <div class="p-2 flex-fill bd-highlight column-chooser-container">
                <h2 class="column-chooser-title">
                    <scrm-label labelKey="LBL_COLUMN_SELECTOR_DISPLAYED_COLS"></scrm-label>
                </h2>

                <div
                    cdkDropList
                    #displayedList="cdkDropList"
                    [cdkDropListData]="displayed"
                    [cdkDropListConnectedTo]="[hiddenList]"
                    class="column-chooser-list"
                    (cdkDropListDropped)="drop($event)">
                    <div class="column-chooser-item column-displayed" *ngFor="let item of displayed"
                         cdkDrag>
                        {{getColumnLabel(item.label)}}
                    </div>
                </div>
            </div>
            <div class="p-2 flex-fill bd-highlight column-chooser-container">
                <h2 class="column-chooser-title">
                    <scrm-label labelKey="LBL_COLUMN_SELECTOR_HIDDEN_COLS"></scrm-label>
                </h2>

                <div
                    cdkDropList
                    #hiddenList="cdkDropList"
                    [cdkDropListData]="hidden"
                    [cdkDropListConnectedTo]="[displayedList]"
                    class="column-chooser-list"
                    (cdkDropListDropped)="drop($event)">
                    <div class="column-chooser-item column-hidden" *ngFor="let item of hidden" cdkDrag>
                        {{getColumnLabel(item.label)}}
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div modal-footer>
        <div class="modal-buttons">
            <scrm-button data-dismiss="modal" [config]="closeButton"></scrm-button>
            <scrm-button [config]="saveButton"></scrm-button>
        </div>
    </div>

</scrm-modal>
